import { lazy } from '@/service/lazy'

export default [{
  name: 'Pacotes Loja',
  path: 'pacotes-unidade',
  id: 'pacotes-unidade',
  icon: 'fa fa-archive',
  component: lazy('app/default/gerenciador/pacotesunidade/index'),
  meta: { requireAuth: true, rules: ['pacote_unidade'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/pacotesunidade.js